import { render, staticRenderFns } from "./InvestorStatusI1.vue?vue&type=template&id=eabd4524"
import script from "./InvestorStatusI1.vue?vue&type=script&lang=js"
export * from "./InvestorStatusI1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports